import { Result, DeleteData } from 'domain/types';

import DeleteWidgetClient from 'use-case/widgets/delete/deleteWidgetClient';
import DeleteWidgetCriteria from 'use-case/widgets/delete/deleteWidgetCriteria';

export type DeleteWidgetResult = Result<DeleteData>;
export type DeleteWidget = (criteria: DeleteWidgetCriteria) => Promise<DeleteWidgetResult>;

export default (deleteWidgetClient: DeleteWidgetClient): DeleteWidget => (criteria: DeleteWidgetCriteria): Promise<DeleteWidgetResult> =>
    deleteWidgetClient(criteria);
